import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enOnboarding from './locales/en/onboarding.json';
import esOnboarding from './locales/es/onboarding.json';

// t() returns a string, never null (matches returnNull: false below).
declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

// Only the onboarding checklist is translated so far; the rest of the portal is still English.
export const LANGUAGES = ['en', 'es'];

const STORAGE_KEY = 'gritsee.lang';

// The language picked with the switcher, remembered per browser. Storage can be blocked (private mode).
export const storedLanguage = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const chooseLanguage = (lng: string) => {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    // Not remembered, but still switched for this visit
  }
  i18n.changeLanguage(lng);
};

i18n.use(initReactI18next).init({
  resources: {
    en: { onboarding: enOnboarding },
    es: { onboarding: esOnboarding },
  },
  lng: storedLanguage() || 'en',
  fallbackLng: 'en',
  returnNull: false,
  interpolation: { escapeValue: false }, // React already escapes
});

export default i18n;
